const GripIcon = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      pointerEvents: 'none',
    }}
  >
    <div
      style={{
        color: 'rgba(0,0,0,0.5)',
        fontSize: '10px',
        lineHeight: '5px',
        userSelect: 'none',
        marginLeft: '1px',
      }}
    >
      ••• •••
    </div>
  </div>
);

export default GripIcon;
